//login signUp button component
const LoginSignUpButton = () => {
  return (
    <div className="text-[gray]">
      New to Crafts?{" "}
      <button type="submit" className="text-secondary-text hover:underline">
        Sign Up Now
      </button>
    </div>
  );
};

export default LoginSignUpButton;
